/* unplugin-vue-components disabled */import { render } from "./switch.vue?vue&type=template&id=18c5ab64&scoped=true"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"

import "./switch.vue?vue&type=style&index=0&id=18c5ab64&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c5ab64"],['__file',"src/controls/switch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18c5ab64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18c5ab64', __exports__)) {
    api.reload('18c5ab64', __exports__)
  }
  
  module.hot.accept("./switch.vue?vue&type=template&id=18c5ab64&scoped=true", () => {
    api.rerender('18c5ab64', render)
  })

}


export default __exports__